export default "__VITE_ASSET__Ceir4Oxd__"